import { Phone, ArrowRight, ArrowDown } from "lucide-react";
import Logo from "./Logo";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative overflow-hidden pt-28 md:pt-36 pb-16 lg:pb-24"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 flex flex-col items-center text-center">
        <p className="font-mono-label text-[11px] text-neutral-500 mb-6">
          <span className="inline-block w-6 h-px bg-neutral-500 align-middle mr-3" />
          Southern Alberta
          <span className="inline-block w-6 h-px bg-neutral-500 align-middle ml-3" />
        </p>

        {/* Centerpiece logo */}
        <div
          data-testid="hero-logo-panel"
          className="w-full flex items-center justify-center -my-8 md:-my-16 lg:-my-24"
        >
          <Logo
            className="w-full max-w-[560px] md:max-w-[720px] lg:max-w-[820px] h-auto"
            alt="The Sim Guys"
          />
        </div>

        <h1
          data-testid="hero-headline"
          className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[1.02] max-w-4xl"
        >
          Custom golf simulators.
          <br />
          <span className="text-neutral-500">Half the price.</span>
        </h1>

        <p className="mt-6 text-base md:text-lg text-neutral-400 max-w-2xl leading-relaxed">
          Local Southern Alberta installer. No corporate distributor markup.{" "}
          <span className="whitespace-nowrap">
            Builds start at{" "}
            <span className="text-[#F5F5F0] font-semibold">$12,000.</span>
          </span>
        </p>

        <div className="mt-10 flex flex-col sm:flex-row gap-3">
          <a
            href="tel:4033935772"
            data-testid="hero-call-cta"
            className="group inline-flex items-center justify-center gap-3 border border-[#F5F5F0] px-7 py-4 font-semibold text-[#F5F5F0] hover:bg-[#F5F5F0] hover:text-black transition-colors"
          >
            <Phone size={16} />
            Call 403-393-5772
          </a>
          <a
            href="#quote-form"
            data-testid="hero-quote-cta"
            className="group inline-flex items-center justify-center gap-3 bg-[#F5F5F0] text-black px-7 py-4 font-semibold hover:bg-[#EAEAE5] transition-colors"
          >
            Request a Free Quote
            <ArrowRight
              size={16}
              className="group-hover:translate-x-1 transition-transform"
            />
          </a>
        </div>

        <p className="mt-6 text-xs text-neutral-500 font-mono-label">
          Save $20K–$40K+ on full turnkey builds · Final quote given in person
        </p>

        <a
          href="#sim-builder"
          aria-label="Scroll to sim builder"
          className="mt-14 inline-flex flex-col items-center gap-2 text-neutral-500 hover:text-[#F5F5F0] transition-colors"
        >
          <span className="font-mono-label text-[10px]">Scroll to build</span>
          <ArrowDown size={16} className="animate-bounce" />
        </a>
      </div>
    </section>
  );
}
